// src/views/balances/actions/components/ContractActionsTable.js
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import TableCell from 'src/components/Table/TableCell';
import { useTranslation } from 'react-i18next';
import TablePaginationCustom from 'src/components/Table/TablePaginationCustom';
import Table from 'src/components/Table';
import ContractActionsRow from './ContractActionsRow';

if (!process.env.REACT_APP_TABLE_SIZE) {
  console.error(
    'REACT_APP_TABLE_SIZE variable not loaded properly. Check your .env file please!'
  );
}

const Tbody = ({ contractActions }) =>
  contractActions.map((item, index) => (
    <ContractActionsRow
      // eslint-disable-next-line react/no-array-index-key
      key={`${item.folio}-${item.action}-${item.date}-${index}`}
      {...item}
    />
  ));

Tbody.propTypes = {
  contractActions: PropTypes.array.isRequired
};

const ContractActionsTable = ({
  contractActions,
  count,
  page,
  handleChangePage,
  loading,
  ...rest
}) => {
  const { t } = useTranslation();

  const theads = useMemo(
    () => () => (
      <TableRow>
        <TableCell variant="head" key="date" align="left">
          {t('COMMON.DATE')}
        </TableCell>
        <TableCell variant="head" key="contract" align="left">
          {t('CONTRACT_ACTIONS.CONTRACT')}
        </TableCell>
        <TableCell variant="head" key="client" align="left">
          {t('COMMON.CLIENT')}
        </TableCell>
        <TableCell variant="head" key="equipment" align="left">
          {t('COMMON.EQUIPMENT')}
        </TableCell>
        <TableCell variant="head" key="event" align="left">
          {t('CONTRACT_ACTIONS.EVENT')}
        </TableCell>
        <TableCell variant="head" key="amount" align="center">
          {t('CONTRACT_ACTIONS.AMOUNT')}
        </TableCell>
      </TableRow>
    ),
    [t]
  );

  const tbody = useMemo(
    () => () => <Tbody contractActions={contractActions} />,
    [contractActions]
  );

  const pagination = useMemo(
    () => () => (
      <TablePagination
        rowsPerPageOptions={[]}
        component="div"
        count={count}
        rowsPerPage={+process.env.REACT_APP_TABLE_SIZE}
        page={page}
        onPageChange={handleChangePage}
        ActionsComponent={TablePaginationCustom}
        labelDisplayedRows={({ from, to, count: c }) =>
          `${from}-${to} ${t('COMMON.OF')} ${c}`
        }
      />
    ),
    [page, count, handleChangePage, t]
  );

  return (
    <Table
      {...rest}
      variant="outlined"
      tbody={tbody}
      theads={theads}
      pagination={pagination}
      loading={loading}
    />
  );
};

ContractActionsTable.propTypes = {
  contractActions: PropTypes.array.isRequired,
  count: PropTypes.number,
  page: PropTypes.number,
  handleChangePage: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

ContractActionsTable.defaultProps = {
  count: 0,
  loading: false
};

export default ContractActionsTable;
